import { configureStore } from '@reduxjs/toolkit';
import snackbarReducer from './reducer/snackbarSlice';
import authUserReducer from './reducer/authUserSlice';
import drawerReducer from './reducer/drawerSlice';
import dialogReducer from './reducer/dialogSlice';
import modalReducer from './reducer/modalSlice';
import permissionReducers from './reducer/permissionSlice';
import financialYearReducer from "./reducer/financialYearSlice";
import sortingReducer from "./reducer/sortingSlice";
import tableSearchReducer from "./reducer/tableSearchSlice";
import showFiltersReducer from "./reducer/showFiltersSlice";
import languageReducer from "./reducer/languageSlice";
import notificationReducer from "./reducer/noticationSlice";
import donorRegistrationReducer from "./reducer/registration/DonorRegistrationSlice";
import implementationAgencyReducer from "./reducer/registration/ImplementationAgencySlice";
import governmentRegistartionReducer from "./reducer/registration/GovernmentSlice";
import projectLocationReducer from './reducer/projectLocationSlice';
import refreshLocationReducer from './reducer/refreshSlice';
import userDetailsReducer from './reducer/userDeatailsSlice';
import registerOtpVerifyReducer from './reducer/regMailVerifySlice';
import donarIndReducer from './reducer/registration/DonorIndivisalSlice';

import refreshSliceReducer from "./reducer/registration/RefreshSlice";
import { ISLIVE } from '../utils/base-urls';

const store = configureStore({
    reducer: {
        snackbar: snackbarReducer,
        authUser: authUserReducer,
        drawer: drawerReducer,
        dialog: dialogReducer,
        modal: modalReducer,
        permissions: permissionReducers,
        financialYear: financialYearReducer,
        sorting: sortingReducer,
        tableSearch: tableSearchReducer,
        showFilters: showFiltersReducer,
        lang: languageReducer,
        notification: notificationReducer,
        donorregistration: donorRegistrationReducer,
        implementationAgency: implementationAgencyReducer,
        govenmentRegistartion: governmentRegistartionReducer,
        projectLocation: projectLocationReducer,
        refreshKey: refreshLocationReducer,
        refreshSlice: refreshSliceReducer,
        userDetails: userDetailsReducer,
        registerMailVerify: registerOtpVerifyReducer,
        individualreg: donarIndReducer,
    },
    devTools: !ISLIVE,
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof import('./store').default.getState>

export default store;

